import { render } from "./PlayManager.vue?vue&type=template&id=19f1e028&scoped=true"
import script from "./PlayManager.vue?vue&type=script&lang=js"
export * from "./PlayManager.vue?vue&type=script&lang=js"

import "./PlayManager.vue?vue&type=style&index=0&id=19f1e028&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f1e028"]])

export default __exports__